<template>
    <div>
        <page-card :header="vers" v-for="(stack, vers) in stacks" v-bind:key="vers" v-if="stack.address !== false">
            <dl>
                <dt>{{ $t('pages.myip.address', {vers: vers}) }}</dt>
                <dd>{{ stack.address }}</dd>
                <dt>{{ $t('pages.myip.campus') }}</dt>
                <dd>
                    <span class="badge" :class="whichBadge(stack.oncampus)"><i class="fa" :class="whichIcon(stack.oncampus)"></i></span>
                    {{ stack.oncampus ? $t('pages.myip.yes') : $t('pages.myip.no') }}
                </dd>
                <dt>{{ $t('pages.myip.vpn') }}</dt>
                <dd>
                    <span class="badge" :class="whichBadge(stack.vpn)"><i class="fa" :class="whichIcon(stack.vpn)"></i></span>
                    {{ stack.vpn ? $t('pages.myip.active') : $t('pages.myip.inactive') }}
                </dd>
            </dl>
        </page-card>
    </div>
</template>
<script>
import GenericNotification from "../layout/GenericNotification";
import LoadingInjector from "../../mixins/LoadingInjector";
import PageCard from "../layout/PageCard";
import Callout from "../layout/Callout";

export default {
    mixins: [
        LoadingInjector
    ],
    components: {
        GenericNotification,
        PageCard,
        Callout,
    },
    props: {},

    data() {
        return {
            notifications: [],
            stacks: {
                v4: {
                    address: false,
                    oncampus: false,
                },
                v6: {
                    address: false,
                    oncampus: false,
                }
            },
        }
    },
    created() {
        this.errorHandler = this.$shared.errorHandlerForResponder;

        // Eject the default response interceptor (see LoadingInjector.js), because v6 query is very likely to fail
        // which would result in an error message the user would not understand
        this.axios.interceptors.response.eject(0);
    },
    mounted() {
        console.log('Mounted MyIp.');

        this.callDecidr(4);
        //this.callDecidr(6);
    },
    methods: {
        callDecidr: function (ipVers) {
            this.axios.get((`https://myip.app.uni-regensburg.de/decidr/single-stack`), {
                timeout: 5000
            })
                .then(response => {
                    this.stacks[`v${ipVers}`] = response.data;
                })
                .catch(error => {

                })
                .finally(() => {
                    this.loading = 0;
                })
        },
        whichBadge: function (val) {
            return (val ? 'badge-success' : 'badge-danger');
        },
        whichIcon: function(val) {
            return (val ? 'fa-check': 'fa-times');
        }
    },
    computed: {}
};
</script>
